import styled from "styled-components";

export const OrderDetail = styled.div`
  margin-top: 25px;
  padding-inline: 12px;

  #order-id {
    font-size: 20px;
  }

  #product-info {
    padding-block: 25px;
  }
`;

export const ProductDetail = styled.div`
  padding-block: 25px;
`;

export const FirstLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
  }
`;

export const SecondLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:nth-child(1) {
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
  }

  span:nth-child(2) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const LineDivider = styled.hr`
  background-color: #d9d9d9;
  height: 1px;
  border: none;
  margin-block: 18px;
`;

export const ShippingContent = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 1085px) {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
`;

export const ShippingInfoType = styled.div`
  width: 70%;
  border: 1px solid #cbcbcb;
  border-radius: 12px;
  padding: 22px 14px;

  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1490px) {
    width: 56%;
  }

  @media screen and (max-width: 1085px) {
    width: 100%;
  }

  #shipping-time {
    margin-bottom: 8px;

    span:nth-child(2) {
      color: #545454;
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
    }
  }

  #track-back {
    color: #0086bf;
    font-weight: 400;
    text-decoration-line: underline;
  }
`;

export const ShippingInfoName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: start;
  margin-block: 16px;

  span {
    margin-left: 18px;
  }
`;

export const ShippingInfoValue = styled.div`
  width: 28%;
  border: 1px solid #cbcbcb;
  border-radius: 12px;
  padding: 22px 14px;

  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1490px) {
    width: 42%;
  }

  @media screen and (max-width: 1085px) {
    width: 100%;
  }
`;

export const ValueMetadada = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 18px;
  line-height: 30px;

  span:nth-child(1) {
    color: #545454;
    font-weight: 400;
  }

  span:nth-child(2) {
    font-weight: 700;
  }
`;
